module.exports = __webpack_public_path__ + "site/img/147.9be79270.jpg";